import { createSlice } from "@reduxjs/toolkit";

const initialAuthSlice = {
  user: null,
  token: null,
  expiresIn: null,
  loginLoading: false,
  refreshLoading: false,
  error: null,
  logoutLoading: false,
  needRefresh: true,
  validationLoading: true,
  validationError: null,
};

export const callTypes = {
  login: "login",
  refreshToken: "refreshToken",
  logout: "logout",
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState: initialAuthSlice,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error?.response?.data;
      switch (action.payload.callType) {
        case callTypes.login:
          state.loginLoading = false;
          break;
        case callTypes.refreshToken:
          state.refreshLoading = false;
          break;
        case callTypes.logout:
          state.logoutLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      console.log("startCall")
      switch (action.payload.callType) {
        case callTypes.login:
          state.loginLoading = true;
          break;
        case callTypes.refreshToken:
          state.refreshLoading = true;
          break;
        case callTypes.logout:
          state.logoutLoading = true;
          break;
        default:
          break;
      }
    },
    loginFetched: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.jwt;
      state.expiresIn = action.payload.expiresIn;
      state.loginLoading = false;
      state.error = null;
    },
    refreshToken: (state, action) => {
      state.token = action.payload.token;
      state.expiresIn = action.payload.expiresIn;
      state.needRefresh = true;
      state.refreshLoading = false;
      state.error = null;
    },
    logoutFetched: (state, action) => {
      state.user = null;
      state.token = null;
      state.expiresIn = null;
      state.loginLoading = false;
      state.refreshLoading = false;
      state.error = null;
      state.logoutLoading = false;
      state.needRefresh = true;
    },
    changeNeedRefresh: (state, action) => {
      state.needRefresh = false;
    },

    validationFetched: (state,action) => {
      state.validationLoading=false;
      state.validationError = null;
      state.user = action.payload.user;
    },
    validationLoading: (state,action) => {
      state.validationLoading=true;
      state.validationError = null;
    },
    
    validationError: (state,action) => {
      state.validationLoading=false;

      if(action.payload.error && action.payload.error.response){
        if(action.payload.error.response.data.user){
          state.user = action.payload.error.response.data.user;
        }else{
          state.user = null;
        }
        state.validationError = action.payload.error?.response?.data.message;
      }else if(action.payload.error){
        state.validationError = action.payload.error.message;
      }else{
        state.validationError = "Unknow Error";
      }      
      
    }
  },
});
